// extracted by mini-css-extract-plugin
module.exports = {"quoteContent":"Quote_quoteContent__n8e1M","quoteAuthor":"Quote_quoteAuthor__DgqUp"};